import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './AdvancedSettings.css';

export default function AdvancedSettings({ onBack }) {
  const { getAuthHeader } = useAuth();
  const [prompts, setPrompts] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(null);

  const copyToClipboard = async (text, id) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(id);
      setTimeout(() => setCopied(null), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  useEffect(() => {
    const fetchPrompts = async () => {
      try {
        const res = await fetch('/api/prompts', {
          headers: { Authorization: getAuthHeader() }
        });

        if (!res.ok) {
          throw new Error('Failed to fetch prompts');
        }

        const data = await res.json();
        if (data.success) {
          setPrompts(data.prompts);
        } else {
          throw new Error(data.error || 'Unknown error');
        }
      } catch (err) {
        console.error('Error fetching prompts:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPrompts();
  }, [getAuthHeader]);

  return (
    <div className="advanced-settings-container">
      <div className="advanced-settings-inner">
        <div className="advanced-settings-header">
          <button className="back-btn" onClick={onBack}>
            &larr; Back
          </button>
          <h2>Advanced Settings</h2>
        </div>

        <div className="advanced-settings-content">
          {loading && (
            <div className="loading-state">Loading prompts...</div>
          )}

          {error && (
            <div className="error-state">Error: {error}</div>
          )}

          {prompts && (
            <>
              <div className="prompt-section">
                <div className="prompt-header">
                  <div>
                    <h3>Command Parsing Prompt</h3>
                    <p className="prompt-description">
                      Used to detect special commands like model switching
                    </p>
                  </div>
                  <button
                    className={`copy-btn ${copied === 'command' ? 'copied' : ''}`}
                    onClick={() => copyToClipboard(prompts.commandDetect, 'command')}
                  >
                    {copied === 'command' ? 'Copied!' : 'Copy'}
                  </button>
                </div>
                <textarea
                  className="prompt-textarea"
                  value={prompts.commandDetect}
                  readOnly
                  rows={8}
                />
              </div>

              <div className="prompt-section">
                <div className="prompt-header">
                  <div>
                    <h3>Jira Assistant Prompt</h3>
                    <p className="prompt-description">
                      Main system prompt for the AI assistant
                    </p>
                  </div>
                  <button
                    className={`copy-btn ${copied === 'assistant' ? 'copied' : ''}`}
                    onClick={() => copyToClipboard(prompts.jiraAssistant, 'assistant')}
                  >
                    {copied === 'assistant' ? 'Copied!' : 'Copy'}
                  </button>
                </div>
                <textarea
                  className="prompt-textarea"
                  value={prompts.jiraAssistant}
                  readOnly
                  rows={20}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
